
export type ErrorMessage = string | null;

export const validation = {
    isValidEmail: (email: string): ErrorMessage => {
        if(email === '') {
            return 'Udfyld venligst alle felter';
        }

        const emailRegex: RegExp = /^[\w+\-.]+@[a-z\d\-.]+\.[a-z]+$/i;
        if(emailRegex.test(email)) {
            return null; 
        }

        return 'Ugyldig email format';
    },
    isMatchEmail: (firstValue: string, secondValue: string): ErrorMessage => {
        if(firstValue === secondValue) {
            return null;  
        }

        return 'Indholdet i de to felter skal være ens';
    },
    isValidPhone: (phone: string): ErrorMessage => {
        if(phone === '') {
            return 'Udfyld venligst alle felter';
        }

        const phoneRegex: RegExp = /^(?:\+?\d{1,3})?\d{8,16}$/;
        if(phoneRegex.test(phone)) {
            return null; 
        }

        return 'Ugyldigt telefonnummer format';
    },
    isMatchPhone: (firstValue: string, secondValue: string): ErrorMessage => {
        if(firstValue === secondValue) {
            return null;  
        }

        return 'Indholdet i de to felter skal være ens';
    },
};